import { HeartHandshake, Target, Telescope } from "lucide-react";
import React, { useEffect } from "react";

const MissionVision = () => {

 useEffect(() => {
  import("aos").then((AOS) => {
    AOS.default.init({
      duration: 500,
      easing: "ease-out-cubic",
      once: true,
      offset: 80,
    });
  });
}, []);

  return (
    <section className="py-10 bg-gradient-to-b lg:px-8 from-[#0b1120] to-[#1a1f35] text-white">
      <div className="container mx-auto px-4 text-center">

        <h2
          className="text-2xl sm:text-3xl md:text-4xl xl:text-5xl font-extrabold mb-6"
          data-aos="fade-down"
        >
          Our{" "}
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-300">
            Mission & Vision
          </span>
        </h2>

        {/* 🚀 EXPANDED INTRO FOR SEO */}
        <p
          className="sm:text-lg text-[16px] text-gray-300 max-w-4xl mx-auto mb-12 leading-relaxed"
          data-aos="fade-up"
          data-aos-delay="150"
        >
          At <span className="text-blue-400 font-semibold">Game Zone Hub</span>, we are driven by a deep passion to provide the absolute best platform to <strong>play free online games</strong>.
          Our ultimate goal is to completely revolutionize the browser gaming industry by creating a sustainable, ad-lite ecosystem where independent developers and passionate players seamlessly connect.
          We continuously strive to build a massive global community firmly rooted in digital safety, inclusivity, and pure, uninterrupted fun for all our <strong>HTML5 online games</strong>.
        </p>

        <ul className="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-1 gap-8 mt-10">

          <li data-aos="zoom-in"  data-aos-delay="200" className="h-full group">
            <div className="bg-[#1e293b] h-full rounded-2xl cursor-pointer shadow-lg p-8 hover:scale-105 transition-transform border border-white/5 hover:border-blue-500/50" >
              <Target className="text-blue-400 w-14 h-14 mx-auto mb-6 group-hover:rotate-12 transition-transform" />
              <h3 className="text-xl font-bold mb-3 text-white">Our Mission</h3>
              <p className="text-gray-400 text-sm leading-6">
                To democratize gaming by providing entirely free access to premium, high-quality entertainment for everyone, regardless of their hardware or device. We relentlessly aim to remove all technological and financial barriers so anyone can <strong>play free online games</strong> instantly, without downloads.
              </p>
            </div>
          </li>
          

          <li data-aos="zoom-in" data-aos-delay="300" className="h-full group">
             <div className="bg-[#1e293b] h-full rounded-2xl cursor-pointer shadow-lg p-8 hover:scale-105 transition-transform border border-white/5 hover:border-yellow-500/50">
                <Telescope className="text-yellow-400 w-14 h-14 mx-auto mb-6 group-hover:-rotate-12 transition-transform" />
                <h3 className="text-xl font-bold mb-3 text-white">Our Vision</h3>
                <p className="text-gray-400 text-sm leading-6">
                  To establish Game Zone Hub as the world's leading, most trusted destination for seamless cross-platform <strong>free browser games</strong>. We envision a highly creative environment where talented independent developers thrive and players of all ages discover incredible new adventures every single day.
                </p>
             </div>
          </li>

          <li data-aos="zoom-in" data-aos-delay="400" className="h-full group">
             <div className="bg-[#1e293b] h-full rounded-2xl cursor-pointer shadow-lg p-8 hover:scale-105 transition-transform border border-white/5 hover:border-purple-500/50">
                <HeartHandshake className="text-purple-400 w-14 h-14 mx-auto mb-6 group-hover:scale-110 transition-transform"/>
                <h3 className="text-xl font-bold mb-3 text-white">Our Core Values</h3>
                <p className="text-gray-400 text-sm leading-6">
                   We prioritize exceptional <strong>User Experience</strong> and unwavering <strong>Digital Safety</strong> above all else. We are deeply committed to maintaining a clean, highly secure, malware-free, and family-friendly platform that is entirely free from intrusive, malicious advertisements and harmful content.
                </p>
             </div>
          </li>

        </ul>
      </div>
    </section>
  );
};

export default MissionVision;